import { useSound } from './useSound.hook';

/**
 * A hook for playing click sound effects
 * @param options Optional configuration options for the sound
 * @returns An object with functions to control the click sound
 */
export const useClickSound = (options?: {
  volume?: number;
  interrupt?: boolean;
  playbackRate?: number;
}) => {
  return useSound('click', {
    volume: options?.volume ?? 0.1, // Lower volume for frequent click sounds
    interrupt: options?.interrupt ?? true, // Allow interrupting to prevent sound overlap
    playbackRate: options?.playbackRate ?? 1,
  });
};
